import React from 'react'

import { Card, CardGroup } from 'components/Card'
import ColorInput from 'components/ColorInput'
import CSSCustomStyle from 'components/CSSCustomStyle'
import ProFeatureLabel from 'components/ProFeatureLabel'
import constants from 'config/constants'
import CustomSurveyURLSection from 'organisms/BrandSettings/CustomSurveyURLSection'
import { images } from 'packages/simplesat-config'
import { Form } from 'semantic-ui-react'

/**
 * @typedef Logo
 * @property {string} imagePreview
 * @property {object} file
 *
 * @param {object} props
 * @param {string} props.backgroundColor
 * @param {function} props.setBackgroundColor
 * @param {string=} props.backgroundImage
 * @param {function} props.setBackgroundImage
 * @param {boolean} props.hasManageBrandsPermission
 * @param {boolean} props.enableCustomizeBranding
 * @param {string} props.customCSS
 * @param {function} props.setCustomCSS
 * @param {string=} props.surveyDomain
 */
export default function BrandWebSurveyStyle({
  backgroundColor,
  setBackgroundColor,
  backgroundImage,
  setBackgroundImage,
  hasManageBrandsPermission,
  customCSS,
  setCustomCSS,
  enableCustomizeBranding,
  surveyDomain,
}) {
  return (
    <Form>
      <Form.Field>
        <ColorInput
          fieldName="Background color"
          colorOptions={constants.BACKGROUND_COLOR_OPTIONS}
          color={backgroundColor}
          defaultColor={backgroundColor}
          onColorChange={setBackgroundColor}
          disabled={!hasManageBrandsPermission}
        />
      </Form.Field>
      <Form.Group>
        <Form.Field width={16}>
          <label>Wallpaper</label>
          <CardGroup className="!mt-1" itemsPerRow={7}>
            <Card
              disabled={!hasManageBrandsPermission}
              active={backgroundImage === null}
              image=""
              onClick={() => setBackgroundImage(null)}
            />
            {images.surveyBackgroundPatterns.map((pattern) => (
              <Card
                disabled={!hasManageBrandsPermission}
                key={pattern.image}
                active={backgroundImage === pattern.image}
                image={pattern.thumbnail}
                onClick={() => setBackgroundImage(pattern.image)}
              />
            ))}
          </CardGroup>
        </Form.Field>
      </Form.Group>
      <CustomSurveyURLSection
        surveyDomain={surveyDomain}
        enableCustomizeBranding={enableCustomizeBranding}
      />
      <Form.Field>
        <label>
          Custom CSS{' '}
          <ProFeatureLabel
            title="Custom CSS"
            content="Custom CSS gives you full control over your web survey's styling and design."
            learnMoreLink="https://help.simplesat.io/en/articles/5051375-survey-branding-design#custom-css"
            shouldShowBillingPageLink={enableCustomizeBranding === false}
          />
        </label>
        <CSSCustomStyle customCSS={customCSS} setCustomCSS={setCustomCSS} />
      </Form.Field>
    </Form>
  )
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/components/BrandWebSurveyStyle/index.js